import { JsonApiDocument } from "../../../../common/ApiSchemaType/Types";

export interface IFieldDetails {
  value: string;
  valid: boolean;
  errorText: string;
}

export enum ExtractModes {
  VIEW = "view",
  CREATE = "Create",
  EDIT = "Edit"
}

export interface IExtract {
  title: IFieldDetails;
  schema?: IFieldDetails;
  survey?: IFieldDetails;
  isActive: boolean;
  description?: string;
  financialYear: string;
  extractGuid?: string;
}

/**
 * Extract metadata that will be displayed in Create Extract Popup / Edit Extract screen
 */
export interface IExtractMetadata {
  /**
   * Extract name
   */
  titleValue: string;
  /**
   * Extract description
   */
  description: string;
  /**
   * Selected financial year in which the extract needs to be created or edited
   */
  financialYear: string;
  /**
   * Schema value of the current extract
   */
  schemaValue: string;
  /**
   * Survey name of the current extract
   */
  surveyValue: string;
}

export interface ICreateExtractState {
  newExtract: IExtract;
  savedExtract: JsonApiDocument | null;
  mode: ExtractModes;
  editExtractDetail: IExtract;
  editPreviousExtractDetail: IExtract;
  isDetailsUpdated: boolean;
}

export interface IErrorDetails {
  /**
   * Define empty field error message
   */
  InvalidErrorText: string;
  /**
   * Define max length
   */
  maxLength: number;
  /**
   * Define exceed maximum length error message
   */
  maxLengthErrorText: string;
}
